"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("pannellum");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _qa = _interopRequireDefault(require("../../../util/qa"));

var _alloyReactIcon = require("@adsk/alloy-react-icon");

var _alloyReactProgressRing = _interopRequireDefault(require("@adsk/alloy-react-progress-ring"));

var _Photo = _interopRequireDefault(require("../Photo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const SphereViewer = _styledComponents.default.div`
  position: relative;
  height: 100%;
`;
const SwitchMode = _styledComponents.default.div`
  z-index: 2;
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 3px;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000052;
  border-radius: 50%;
  color: white;
  &:hover {
    transform: scale(1.1);
    cursor: pointer;
  }
`;
const Icon360 = (0, _styledComponents.default)(_alloyReactIcon.Photo360Icon)`
  position: absolute;
  margin-top: 1px;
`;
const IconLine = (0, _styledComponents.default)(_alloyReactIcon.ShapeLineIcon)`
  z-index: -1;
  position: relative;
  visibility: ${props => props.usePannellum ? "hidden" : "visible"};
`;
const Viewer = _styledComponents.default.div`
  .pnlm-load-box {
    display: none !important;
  }

  .pnlm-container {
    background: white;
  }
`;
const ControlsContainer = _styledComponents.default.div`
  position: absolute;
  width: 26px;
  top: 56px;
  left: 4px;
  z-index: 2;
`;
const IconControls = (0, _styledComponents.default)(_alloyReactIcon.ArrowFullScreenIcon)`
  background-color: white;
  border: 1px solid #8595a1;
  border-radius: 3px;
  cursor: pointer;
  z-index: 3;
  margin-top: 8px;
  width: 100%;
  height: 100%;
  &:hover {
    background-color: #f8fafb;
  }
`;
const StyledSpinner = (0, _styledComponents.default)(_alloyReactProgressRing.default)`
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -16px;
  margin-top: -16px;
  z-index: 1;
`;

const MediaSphereViewer = ({
  media
}) => {
  const sphereRef = (0, _react.useRef)(null);
  const switchModeRef = (0, _react.useRef)(null);
  const [usePannellum, setUsePannellum] = (0, _react.useState)(true);
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const viewer = (0, _react.useRef)(null); // pannellum does not have typings available yet, so make any to avoid ts errors

  (0, _react.useEffect)(() => {
    if (sphereRef && sphereRef.current && media.fullUrl) {
      //@ts-ignore
      viewer.current = window.pannellum.viewer(sphereRef.current, {
        type: "equirectangular",
        panorama: media.fullUrl,
        preview: media.fullUrl,
        showFullscreenCtrl: false,
        autoLoad: true,
        disableKeyboardCtrl: true
      }); // @ts-ignore

      viewer.current.on("load", () => {
        setIsLoading(false);
      });
    }
  }, [sphereRef, media.fullUrl, usePannellum]);
  const toggleFullscreen = (0, _react.useCallback)(() => {
    viewer.current.toggleFullscreen();
  }, []);
  return /*#__PURE__*/_react.default.createElement(SphereViewer, null, /*#__PURE__*/_react.default.createElement("link", {
    rel: "stylesheet",
    href: "https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.css"
  }), /*#__PURE__*/_react.default.createElement(SwitchMode, {
    ref: switchModeRef
  }, /*#__PURE__*/_react.default.createElement(Icon360, {
    onClick: () => {
      setUsePannellum(!usePannellum);
    },
    size: 28
  }), /*#__PURE__*/_react.default.createElement(IconLine, {
    size: 32,
    usePannellum: usePannellum
  })), usePannellum ? /*#__PURE__*/_react.default.createElement(Viewer, {
    "data-qa": _qa.default.media,
    ref: sphereRef
  }, isLoading && /*#__PURE__*/_react.default.createElement(StyledSpinner, {
    size: _alloyReactProgressRing.default.SIZES.LARGE
  }), /*#__PURE__*/_react.default.createElement(ControlsContainer, null, /*#__PURE__*/_react.default.createElement(IconControls, {
    onClick: toggleFullscreen,
    size: 24
  }))) : /*#__PURE__*/_react.default.createElement(_Photo.default, {
    src: media.fullUrl || media.fileUrl
  }));
};

var _default = MediaSphereViewer;
exports.default = _default;